module.exports = __webpack_public_path__ + "static/media/trench-shoring.98545e3e.jpg";